module.exports = __webpack_public_path__ + "static/media/4.06313d5b.svg";